// extracted by mini-css-extract-plugin
export var content = "_87-1";
export var modal = "_87-0";